import { httpRequest } from "@/utils/HttpRequest";
import { appHttpRequest } from "@/utils/AppHttpRequest";
import { IPage } from "@/types/FmsTypes";
import {
    ApprovalShopFields,
    OrgFields,
    UserFields,
    ApprovalFlowFields,
    ApprovalFlowInsertFields,
    ApprovalFlowUpdateFields,
} from "./ApprovalTypes";

class ApprovalService {

    async getApprovalShop() {
        const apiUrl = `/approval_flow/getApprovalShop`;
        return await httpRequest.get<ApprovalShopFields[]>(apiUrl);
    }

    async insert(param: ApprovalFlowInsertFields) {
        const apiUrl = `/approval_flow/insert`;
        return await httpRequest.post<boolean>(apiUrl, param);
    }

    async update(param: ApprovalFlowUpdateFields) {
        const apiUrl = `/approval_flow/update`;
        return await httpRequest.post<boolean>(apiUrl, param);
    }

    async delete(id: string) {
        const apiUrl = `/approval_flow/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    async getShopFlow(shopCode: string) {
        const apiUrl = `/approval_flow/getShopFlow/0/${shopCode}`;
        return await httpRequest.get<ApprovalFlowFields[]>(apiUrl);
    }

    async allOrgTree(searchVo: any) {
        const apiUrl = `/portal/org/allTree`;
        return await appHttpRequest.post<OrgFields[]>(apiUrl, searchVo);
    }

    async oneOrgTree(searchVo: any) {
        const apiUrl = `/portal/org/oneTree`;
        return await appHttpRequest.post<OrgFields>(apiUrl, searchVo);
    }

    async getUser(searchVo: any) {
        const apiUrl = `/portal/auth/user/findUserDetail`;
        return await appHttpRequest.post<IPage<UserFields>>(apiUrl, searchVo);
    }

    async updateUser(param: any) {
        const apiUrl = `/portal/auth/user/update`;
        return await appHttpRequest.post<boolean>(apiUrl, param);
    }

}

export const approvalService = new ApprovalService();
